/** Paddy stack-sample lab parameters (incoming grain analysis). */

export const DEFAULT_PADDY_LAB_VALUES = {
  moisture_pct: "",
  yield_pct: "",
  broken_pct: "",
  damage_pct: "",
  green_pct: "",
  immature_pct: "",
  admixture_pct: "",
  pr_pct: "",
  length_mm: "",
  choba_pct: "",
  kachri_pct: "",
  custom_param_1_name: "",
  custom_param_1_value: "",
  custom_param_2_name: "",
  custom_param_2_value: "",
  notes: "",
};

/** Fixed metrics shown in forms and approval grids. */
export const PADDY_LAB_METRICS = [
  { key: "moisture_pct", label: "Moisture", suffix: "%" },
  { key: "yield_pct", label: "Yield", suffix: "%" },
  { key: "broken_pct", label: "Broken", suffix: "%" },
  { key: "damage_pct", label: "Damage / Discolour", suffix: "%" },
  { key: "green_pct", label: "Green", suffix: "%" },
  { key: "immature_pct", label: "Immature", suffix: "%" },
  { key: "admixture_pct", label: "Admixture", suffix: "%" },
  { key: "pr_pct", label: "PR", suffix: "%" },
  { key: "length_mm", label: "Length", suffix: " mm" },
  { key: "choba_pct", label: "Choba", suffix: "%" },
  { key: "kachri_pct", label: "Kachri", suffix: "%" },
];

/** Default company absolute ranges (kept in sync with backend COMPANY_LAB_VALIDATION_LIMITS). */
export const DEFAULT_COMPANY_LAB_LIMITS = {
  moisture_pct: { min: 9, max: 35 },
  yield_pct: { min: 55, max: 80 },
  broken_pct: { min: 5, max: 50 },
  damage_pct: { min: 0, max: 100 },
  green_pct: { min: 0, max: 100 },
  immature_pct: { min: 0, max: 100 },
  admixture_pct: { min: 0, max: 100 },
  pr_pct: { min: 0, max: 100 },
  length_mm: { min: 0, max: 10 },
  choba_pct: { min: 0, max: 100 },
  kachri_pct: { min: 0, max: 100 },
};

export function formatPaddyLabMetric(lab, { key, suffix }) {
  if (!lab || lab[key] == null || lab[key] === "") return "—";
  return `${lab[key]}${suffix}`;
}

export function isPaddyLabMetricOutOfRange(lab, key) {
  if (!lab || lab[key] == null || lab[key] === "") return false;
  if (Array.isArray(lab.out_of_range)) return lab.out_of_range.includes(key);
  return false;
}

export function paddyLabMetricClass(lab, key, base = "") {
  return isPaddyLabMetricOutOfRange(lab, key)
    ? `${base} text-red-600 font-semibold`.trim()
    : base;
}

export function formatLabLimitHint(limits, key, suffix = "%") {
  if (!limits || !limits[key]) return null;
  const { min, max } = limits[key];
  const parts = [];
  if (min != null && min !== "") parts.push(`min ${min}${suffix}`);
  if (max != null && max !== "") parts.push(`max ${max}${suffix}`);
  return parts.length ? parts.join(" · ") : null;
}
